<template>
  <div class="resize-handle">
    <div
      v-touch-pan.prevent.mouse="onDrag"
      class="resize-handle--thumb"
      @dblclick="size = initialSize"
    >
      <div class="resize-handle--area" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { clone } from 'lodash'

defineOptions({ name: 'SanCommonResizer' })
const emit = defineEmits(['update:modelValue'])
const props = defineProps({
  modelValue: { type: Number, default: null },
  type: { type: String, default: null },
  limits: { type: Array, default: null },
  isReversed: { type: Boolean, default: false }
})

const size = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val)
})

const initialSize = clone(props.modelValue)
const updatedSize = ref(initialSize)

const onDrag = e => {
  let offset
  switch (props.type) {
    case 'left':
      offset = e.offset.x * -1
      break
    case 'right':
      offset = e.offset.x
      break
    case 'top':
      offset = e.offset.y * -1
      break
    case 'bottom':
      offset = e.offset.y
      break
    default:
      offset = 0
      break
  }

  if (e.isFirst === true) {
    updatedSize.value = props.modelValue
  }

  const calcSize = updatedSize.value + offset
  if (calcSize > props.limits[0] && calcSize < props.limits[1]) size.value = calcSize
}
</script>
